import axios from "axios";
import {WORKFLOW_API_HOST} from "@/core/variables";
import {BulkTestJobDefaultParams} from "@/model/Job";

class WorkflowJobRepository {
    async paginate(page: number, size: number) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflow-jobs`, {
            params: {
                page: page,
                size: size
            }
        });
    };

    async bulkTestWorkflow(workflowUserId: string, workflowId: string, file: File, defaultParams: BulkTestJobDefaultParams) {
        let form = new FormData();
        form.append("file", file);
        form.append('workflowId', workflowId)
        form.append('userId', workflowUserId)
        form.append('defaultParams', JSON.stringify(defaultParams))

        return axios.post(
            `${WORKFLOW_API_HOST}/v2/workflow-jobs/bulk-test`,
            form,
            {
                headers: {"Content-Type": "multipart/form-data"},
                timeout: 30000
            }
        );
    };

    async interrupt(jobId: string) {
        return axios.post(`${WORKFLOW_API_HOST}/v2/workflow-jobs/${jobId}/interrupt`);
    };

    async read(jobId: string) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflow-jobs/${jobId}`);
    };

    async export(jobId: string) {
        return axios.getUri({
            url: `${WORKFLOW_API_HOST}/v2/workflow-jobs/${jobId}/export`,
            responseType: "blob"
        });
    }
}

const jobRepository = new WorkflowJobRepository();
export default jobRepository